import React from 'react';
import { SText } from 'src/components/SText';

type Props = {
  testID?: string;
  label: string;
  value: string;
};

export const RecapInfoItem: React.FC<Props> = ({ label, value, testID = 'RecapInfoItem' }) => {
  return (
    <div data-testid={testID} className="my-2 flex flex-row">
      <div className="w-2/5">
        <SText label={label} classNames="text-gray-600 text-lg font-light" />
      </div>
      <div className="ml-2">
        <SText label={value} classNames="text-gray-600 text-lg font-light" />
      </div>
    </div>
  );
};
